export var E_Freq;
(function (E_Freq) {
    E_Freq["quarterly"] = "quarterly";
    E_Freq["monthly"] = "monthly";
    E_Freq["weekly"] = "weekly";
    E_Freq["daily"] = "daily";
})(E_Freq || (E_Freq = {}));
